module.exports = __webpack_public_path__ + "img/V1.f1a31629.png";